export const iconFontAwesomeMapsEye = (
	<i className="fa-solid fa-eye"></i>
);
